<template>
    
    <div class="sidebar primary" id="dvSidebarPrimary"
        @mouseenter="onSidebarMouseEnter"
        @mouseleave="onSidebarMouseLeave"
    >

        <!--Header Section-->

        <div class="sidebar-header">
            <div class="header-button">
                <div class="button">
                    <a class="btn btn-block btn-header" id="sidebarToggle" @click="toggleSidebar">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="14" viewBox="0 0 21 14" fill="none">
                            <path d="M1.47656 7H19.8392M1.47656 13H19.8392M1.47656 1H19.8392" stroke="#CACACA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
        <div class="sidebar-header">
            <div class="header-button">
                <div class="button">
                    <a class="btn btn-block btn-header" @click="goToHome">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z" stroke="#CACACA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 22V12h6v10" stroke="#CACACA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
        <div class="sidebar-header">
            <div class="header-button">
                <div class="button">
                    <a class="btn btn-block btn-header" @click="openModalUser">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#CACACA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z" stroke="#CACACA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </a>
                </div>
            </div>
        </div>


        <!--Content Section-->

        <div class="sidebar-content">
            <div class="content-button">
                <div class="button">
                    <a class="btn btn-block btn-content" @click="openModalUser">
                        <span class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="38" viewBox="0 0 35 38" fill="none">
                                <path d="M16.8021 25.8132V11H19.3158V25.8132H16.8021ZM10.6523 19.6635V17.1497H25.4656V19.6635H10.6523Z" fill="#29BBFF" />
                            </svg>
                        </span>
                    </a>
                </div>
            </div>
        </div>
        
    </div>

    <!--Sidebar - Secondary-->

    <div class="section sidebar secondary" :class="{ 'active': !showSecondaySideBar }"
        @mouseenter="onSidebarMouseEnter"
        @mouseleave="onSidebarMouseLeave"
    >

        <!--Header Section-->

        <div class="sidebar-header">
            <div class="header-dropdown" @click="this.emailUser = null">
                <div class="dropdown">
                    <a class="link-dropdown" href="javascript:void(0);" id="dropdownSidebarSecondary" data-bs-toggle="dropdown" aria-expanded="false">
                        <span class="icon">
                            <img src="/assets/images/logo/logo-escolarai-a.svg" class="logo-escolarai-a"/>

                        </span>
                        <span class="text">

                        </span>
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <div class="menu-text">
                            <div class="title">
                                <h3>
                                    Gerencie a equipe
                                </h3>
                            </div>
                        </div>
                        <div class="menu-form">
                            <div class="form-group">
                                <div class="form-input">
                                    <input type="search" class="form-control" placeholder="Pesquise ou adicione pessoas" v-model="emailUser" @input="filterUsers"/>
                                </div>
                                <button type="button" class="btn btn-block btn-form" @click="inviteUser" v-if="emailUser">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                        <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM504 312l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"/>
                                    </svg>
                                </button>
                            </div>
                            <small v-if="emailUser && filteredUsers.length === 0" style="color: #29BBFF;">Um convite será enviado para o e-mail informado.</small>

                        </div>
                        <div class="menu-caption" v-if="filteredUsers.length > 0">
                            <div class="caption">
                                <span>
                                    Pessoas com acesso
                                </span>
                            </div>
                        </div>
                        <div class="menu-list">
                            <div v-if="loading" class="loader-container">
                                <div class="loader"></div>
                            </div>
                            <ul v-else>
                                <li v-for="user in filteredUsers" :key="user.id">
                                    <div class="list-wrapper primary">
                                        <div class="wrapper-inner">
                                            <div class="list-icon">
                                                <div class="icon nameInitials">
                                                    {{ user.name.charAt(0) }}{{ user.name.charAt(1) }}
                                                </div>
                                            </div>
                                            <div class="list-text">
                                                <div class="title">
                                                    <h3>
                                                        {{ user.name }}
                                                    </h3>
                                                </div>
                                                <div class="subtitle">
                                                    <h4>
                                                        {{ user.email }}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wrapper-inner">
                                            <div class="list-button">
                                                <div class="button">
                                                    <button type="button" class="btn btn-block btn-list">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                                            <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                              
                            </ul>
                        </div>
                        <div class="menu-button" v-if="filteredUsers.length > 0">
                            <div class="button">
                                <button class="btn btn-block btn-menu secondary" type="button" @click="toggleSidebar">
                                    Cancelar
                                </button>
                            </div>
                            <div class="button">
                                <button class="btn btn-block btn-menu primary" type="button">
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Content Section-->

        <div class="sidebar-content">
            <div class="content-accordion">
                <div class="accordion" id="accordionSidebarSecondaryContent">
                    <div class="accordion-item">
                        <div class="accordion-header" id="heading-1-SidebarSecondaryContent">
                            <div class="header-link">
                                <div class="link">
                                    <a class="link-header" data-bs-toggle="collapse" data-bs-target="#collapse-1-SidebarSecondaryContent" aria-expanded="true" aria-controls="collapse-1-SidebarSecondaryContent">
                                        <span class="icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M8 4V8L10.6667 9.33333" stroke="#CEFF1F" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                                <circle cx="8" cy="8" r="6" stroke="#CEFF1F" stroke-width="1.33333"/>
                                            </svg>
                                        </span>
                                        <span class="text">
                                            Histórico
                                        </span>
                                    </a>
                                </div>
                            </div>
                     
                        </div>
                        <div id="collapse-1-SidebarSecondaryContent" class="accordion-collapse collapse show" aria-labelledby="heading-1-SidebarSecondaryContent" data-bs-parent="#accordionSidebarSecondaryContent">
                            <div class="accordion-body">
                                <div class="body-link">
                                    <div v-if="loading" class="loader-container">
                                        <div class="loader"></div>
                                    </div>
                                    <div v-else class="link" v-for="order in ordersHistoryLocal.slice(0, 5)" :key="order.id">
                                        <a class="link-body"  @click="goToChat(order)">
                                            {{ order.title }}
                                        </a>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="accordion-item">
                        <div class="accordion-header" id="heading-2-SidebarSecondaryContent">
                            <div class="header-link">
                                <div class="link">
                                    <a class="link-header" data-bs-toggle="collapse" data-bs-target="#collapse-2-SidebarSecondaryContent" aria-expanded="true" aria-controls="collapse-2-SidebarSecondaryContent">
                                        <span class="icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M7.99999 1.33334L10.0607 5.50668L14.6667 6.18001L11.3333 9.42668L12.1213 14.0133L7.99999 11.8467L3.87866 14.0133L4.66666 9.42668L1.33333 6.18001L5.93933 5.50668L7.99999 1.33334Z" stroke="#CEFF1F" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                        <span class="text">
                                            Favoritos
                                        </span>
                                    </a>
                                </div>
                            </div>
                     
                        </div>
                        <div id="collapse-2-SidebarSecondaryContent" class="accordion-collapse collapse" aria-labelledby="heading-2-SidebarSecondaryContent" data-bs-parent="#accordionSidebarSecondaryContent">
                            <div class="accordion-body">
                                <div class="body-link">
                                    <div v-if="loading" class="loader-container">
                                        <div class="loader"></div>
                                    </div>
                                    <div v-else class="link" v-for="order in favoriteOrders.slice(0, 10)" :key="order.id">
                                        <a class="link-body"  @click="goToChat(order.id)">
                                            {{ order.title }}
                                        </a>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="accordion-item" v-for="(orderCrew, index) in ordersCrews" :key="orderCrew.id">
                        <div class="accordion-header" :id="'heading-crew-' + index">
                            <div class="header-link">
                                <div class="link">
                                    <a class="link-header collapsed" href="javascript:void(0);" data-bs-toggle="collapse" :data-bs-target="'#collapse-crew-' + index" aria-expanded="false" :aria-controls="'collapse-crew-' + index">
                                        <span class="icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <circle cx="8.00016" cy="8.00016" r="6" stroke="#CEFF1F" stroke-width="1.33333" />
                                                <path d="M10.0002 8.00016C10.0002 9.77801 9.7107 11.3569 9.2668 12.4666C9.0441 13.0233 8.79561 13.4291 8.55378 13.6849C8.31328 13.9392 8.12597 14.0002 8.00016 14.0002C7.87435 14.0002 7.68704 13.9392 7.44655 13.6849C7.20472 13.4291 6.95622 13.0233 6.73353 12.4666C6.28962 11.3569 6.00016 9.77801 6.00016 8.00016C6.00016 6.22231 6.28962 4.64347 6.73353 3.53371C6.95622 2.97698 7.20472 2.57118 7.44655 2.31547C7.68704 2.06116 7.87435 2.00016 8.00016 2.00016C8.12597 2.00016 8.31328 2.06116 8.55378 2.31547C8.79561 2.57118 9.0441 2.97698 9.2668 3.53371C9.7107 4.64347 10.0002 6.22231 10.0002 8.00016Z" stroke="#CEFF1F" stroke-width="1.33333" />
                                                <path d="M2 8H14" stroke="#CEFF1F" stroke-width="1.33333" stroke-linecap="round" />
                                            </svg>
                                        </span>
                                        <span class="text">
                                            {{ orderCrew.name.length > 18 ? orderCrew.name.substring(0,18) + '...' : orderCrew.name }}
                                        </span>
                                    </a>
                                </div>
                            </div>
                           
                        </div>
                        <div :id="'collapse-crew-' + index" class="accordion-collapse collapse" :aria-labelledby="'heading-crew-' + index" data-bs-parent="#accordionSidebarSecondaryContent">
                            <div class="accordion-body">
                                <div class="body-link">
                                    <div v-if="loading" class="loader-container">
                                        <div class="loader"></div>
                                    </div>
                                    <div v-else class="link" v-for="orderCrewOrder in orderCrew.orders.slice(0, 5)" :key="orderCrewOrder.id" >
                                        <a class="link-body"  @click="goToChat(orderCrewOrder.id)">
                                            {{ orderCrewOrder.name }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="version">
                <p>Versão: 1.0.1 - 15/05/25</p>
                <p>@Copyright Escolar.Ai</p>
            </div>
        </div>

    </div>
    
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { toast } from 'vue3-toastify';

import users from '@/utils/users';
import order from '@/utils/order';
import UserApi from '@/utils/users';

export default {
    name: 'PrimarySidebar',
    data() {
        return {
            users: [],
            ordersHistoryLocal: [],
            ordersCrews: [],
            showSecondaySideBar:false,
            favoriteOrders: [],
            emailUser: '',
            loading: false,
            sidebarHover: false,
            sidebarTimeout: null
        };
    },
    computed: {
        ...mapState(['token', 'userInfoData', 'crewsList', 'account', 'ordersHistory', 'orderByCrewsHistory', 'favoriteOrdersHistory']),
        filteredUsers() {
            if (!this.emailUser) {
                return this.users;
            }
            // Protege contra valores nulos ou indefinidos em user.email e user.name
            return this.users.filter(user => {
                const email = user.email ? user.email.toLowerCase() : '';
                const name = user.name ? user.name.toLowerCase() : '';
                const search = this.emailUser ? this.emailUser.toLowerCase() : '';
                return email.includes(search) || name.includes(search);
            });
        }
    },
    methods: {
        ...mapActions(['getUsers', 'storeIsVisibleModalUser', 'storeCurrentCrewHistory', 'storeOrdersHistory', 'storeOrderByCrewsHistory', 'storeFavoriteOrdersHistory']),
        toggleSidebar(){
            this.showSecondaySideBar = !this.showSecondaySideBar;
        },
        inviteUser(){
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.emailUser)) {
                this.notify('E-mail inválido', 'error');
                return;
            }
            const payload = {
                "email": this.emailUser,               
            }

            try {
                UserApi.inviteUser(this.token, payload);
                this.notify('Usuário convidado com sucesso', 'success');
            } catch (error) {
                console.error('Erro ao convidar usuário:', error);
            }
        },
        notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: this.isMobile ? 'top-center' : 'top-right',
                theme: "light", 
                type: type,
                dangerouslyHTMLString: true
            });
        },
        goToHome(){
            console.log('hide')
            this.showSecondaySideBar = true;
            console.log(this.showSecondaySideBar)
            setTimeout(() => {
                window.location = '/tela-principal';
            }, 500);
        },
        async getUsers() {
            try {
                this.loading = true;
                const response = await users.getUsers(this.token);
                this.users = response;
            } catch (error) {
                console.error('Erro ao buscar usuários:', error);
            } finally {
                this.loading = false;
            }
        },
        async getListOrders() {
            try {
                this.loading = true;
                const response = await order.getListOrders(this.token);
                this.storeOrdersHistory({ ordersHistory: response });
                this.ordersHistoryLocal = response;
            } catch (error) {
                console.error('Erro ao buscar pedidos:', error);
            } finally {
                this.loading = false;
            }
        },
        async getOrderByCrews() {
            try {
                this.loading = true;
                const response = await order.getOrderByCrews(this.token);
                this.storeOrderByCrewsHistory({ orderByCrewsHistory: response });
                this.ordersCrews = response;
            } catch (error) {
                console.error('Erro ao buscar pedidos:', error);
            } finally {
                this.loading = false;
            }
        },
        async getFavoriteOrders() {
            try {
                this.loading = true;
                const response = await order.getFavoriteOrders(this.token);
                this.storeFavoriteOrdersHistory({ favoriteOrdersHistory: response });
                this.favoriteOrders = response;
            } catch (error) {
                console.error('Erro ao buscar pedidos favoritados:', error);
            } finally {
                this.loading = false;
            }
        },
        openModalUser() {
            this.storeIsVisibleModalUser({ isVisibleModalUser: true });
        },
        goToChat(crew){
            this.storeCurrentCrewHistory({ currentCrewHistory: crew });
            this.$router.push(`/conversa-em-andamento/${crew.id}`);
        },
        onSidebarMouseEnter() {
            this.sidebarHover = true;
            if (this.sidebarTimeout) {
                clearTimeout(this.sidebarTimeout);
                this.sidebarTimeout = null;
            }
        },
        onSidebarMouseLeave() {
            this.sidebarHover = false;
            if (this.sidebarTimeout) {
                clearTimeout(this.sidebarTimeout);
                this.sidebarTimeout = null;
            }
            // Aguarda 5 segundos e só oculta se o mouse não voltou para a sidebar
            this.sidebarTimeout = setTimeout(() => {
                if (!this.sidebarHover && !this.showSecondaySideBar) {
                    this.toggleSidebar();
                }
            }, 5000);
        }
    },
    mounted() {
        this.getUsers();
        if (window.location.href.includes('/tela-principal') || !this.ordersHistory || !this.orderByCrewsHistory || !this.favoriteOrdersHistory) {
            this.getListOrders();
            this.getOrderByCrews();
            this.getFavoriteOrders();
        } else {
            this.loading = true;
            this.ordersHistoryLocal = this.ordersHistory;
            this.ordersCrews = this.orderByCrewsHistory;
            this.favoriteOrders = this.favoriteOrdersHistory;
        }
        // Não chama mais toggleSidebar automaticamente ao montar, pois agora é controlado pelo mouse
        // setTimeout(() => {
        //     this.toggleSidebar();
        // }, 5000);
    }
};
</script>

<style lang="scss" scoped>
.icon.nameInitials {
    background-color: #7e9784;
    color: white;
    padding: 8px;
    border-radius: 50%;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
}
.sidebar.secondary {
    position: absolute;
    display: flex;
    height: 100% !important;
    padding: 1.5rem !important;
    flex-direction: column;
    flex-shrink: 0;
    z-index: 100;
    width: 270px;
    top: 0;
    left: -35%;
    background-color: #212226;
    transition: .4s ease;
}
.sidebar.secondary.active {
    left: 4%;
    transition: .4s ease;
}
.menu-form {
    margin-bottom: 1rem;

    .form-group {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        .form-input {
            flex: 1;

            .form-control {
                width: 100%;
                padding: 0.5rem;
                background-color: #2c2d31;
                border: 1px solid #3c3d42;
                border-radius: 4px;
                color: #fff;

                &::placeholder {
                    color: #8b8c91;
                }

                &:focus {
                    outline: none;
                    border-color: #ceff1f;
                }
            }
        }

        .btn-form {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 12px 10px;
            background-color: #ceff1f;
            border: none;
            border-radius: 4px;
            color: #212226;
            cursor: pointer;

            &:hover {
                background-color: #b8e61b;
            }

            svg {
                width: 20px;
                height: 20px;
            }
        }
    }
}
button.btn.btn-block.btn-list {
    background-color: #ceff1f;
}
button.btn.btn-block.btn-list svg {
    width: 20px !important;
    height: 20px !important;
}
button.btn.btn-block.btn-list {
    background-color: #ceff1f;
    padding: 1px 22px !important;
    width: 37px;
}
.version {
    color: white;
    position: absolute;
    bottom: 0;
    text-align: center;
    width: 100%;
    left: 0;
}
.version p {
    margin: 0;
    color: gray;
    font-size: 11px;
}
a.link-body {
    text-align: left;
}
.logo-escolarai-a {
    width: 100px!important;
}
.body-link > .link a.link-body {
    cursor: pointer;
}
.accordion-header a.link-header {
    cursor: pointer;
}
</style>
